import React, {ReactNode} from 'react';

interface Props {
  style?: any;
  className?: any;
  children: ReactNode;
}

const Container: React.FC<Props> = (props) => {
  return (
    <div className={`grid ${props.className}`} style={props.style}>
      {props.children}
    </div>
  );
};
export default Container;
